import React, { useContext, useEffect } from "react";
import "./App.css";
import { RunnerContext } from "./context/RunnerContext";
import { Login } from "./presentation/login/Login";
import { StartRun } from "./presentation/startRun/StartRun";
import { AbsolvedRuns } from "./presentation/absolvedRuns/AbsolvedRuns";
import { Path } from "./presentation/shared/Path";
import {
  Route,
  Routes,
  useHref,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Dashboard } from "./presentation/home/Dashboard";
import { useRunsController } from "./controller/runs/useRunsController";
import { Detail } from "./presentation/detail/Detail";
import { Button } from "./components/ui/button";
import { ReactComponent as Logo } from "./assets/run-zone-logo.svg";

function App() {
  const { runner } = useContext(RunnerContext);
  const runsController = useRunsController();
  const basename = useHref("/");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    runsController.initRuns();
    runsController.initRunner();
  }, []);

  if (!runner) {
    return (
      <div>
        <Login />
      </div>
    );
  }

  const buttonClasses = "md:w-64 w-1/3 h-full";
  const activeClasses =
    "font-bold text-2xl border-b-2 border-b-white border-b-2";
  const inactiveClasses = "dark:text-slate-500";
  return (
    <div className="w-full h-screen flex flex-col font-nunito font-semibold dark:bg-slate-950 items-center">
      <Logo
        className={
          "absolute w-64 h-64 bottom-16 left-1/2 -translate-x-1/2 text-slate-800"
        }
      />
      <div className="flex-grow max-w-maxContent w-full relative">
        <Routes>
          <Route path={Path.ROOT} element={<Dashboard />} />
          <Route path={Path.NEW} element={<StartRun />} />
          <Route path={Path.RUNS} element={<AbsolvedRuns />} />
          <Route path={Path.DETAIL} element={<Detail />} />
        </Routes>
      </div>
      <div
        className={"w-full flex gap-1 h-16 md:h-10 dark:bg-slate-950 text-xl"}
      >
        <Button
          variant={"custom"}
          className={
            location.pathname === Path.ROOT
              ? buttonClasses + " " + activeClasses
              : buttonClasses + " " + inactiveClasses
          }
          onClick={() => navigate(Path.ROOT)}
        >
          Home
        </Button>
        <Button
          variant={"custom"}
          className={
            location.pathname === Path.NEW
              ? buttonClasses + " " + activeClasses
              : buttonClasses + " " + inactiveClasses
          }
          onClick={() => navigate(Path.NEW)}
        >
          Go!
        </Button>
        <Button
          variant={"custom"}
          className={
            location.pathname === Path.RUNS
              ? buttonClasses + " " + activeClasses
              : buttonClasses + " " + inactiveClasses
          }
          onClick={() => navigate(Path.RUNS)}
        >
          Runs
        </Button>
      </div>
    </div>
  );
}

export default App;
